<template>
  <div style="font-size: 14px">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>项目名称：{{ projectBase.projectName }}</span>
      </div>
      <el-row>
        <el-col :span="12">
          <div class="text item">
            开始时间：{{ projectBase.projectStartTime }}
          </div>
          <div class="text item">
            结束时间：{{ projectBase.projectEndTime }}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="text item">
            排行榜维度：
            <span v-if="projectBase.projectRankType && projectBase.projectRankType == 2
            ">年化金额</span>
            <span v-else>总金额</span>
          </div>
        </el-col>
        <el-col :span="4">
          <el-button v-if="updateProjectRankType" style="padding: 3px 0" type="text"
            @click="toUpdateProjectRankType">修改</el-button>
        </el-col>
      </el-row>
      <el-row>
        <div class="text item">项目描述：{{ projectBase.projectRemark }}</div>
      </el-row>
    </el-card>
    <el-card class="box-card">
      <el-row>
        <el-col :span="6">
          <div class="text item">
            订单提交截止时间：{{ projectBase.projectOrderTimeEnd }}
          </div>
        </el-col>
        <el-col :span="4">
          <el-button v-if="updateProjectOrderTimeEnd" style="padding: 3px 0" type="text"
            @click="toUpdateProjectOrderTimeEnd">修改</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="text item">
            项目经理：{{ projectBase.projectManagerIdListString }}
          </div>
          <div class="text item">
            项目老师：{{ projectBase.projectTeacherIdListString }}
          </div>
          <div class="text item">
            其他人员：{{ projectBase.projectOtherIdListString }}
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card>

      <el-row>
        <el-col :span="6">
          <p>微课匹配度校验:<span>{{ projectBase.microlecturePassStatus == 1 ? '不校验' : '校验' }}</span></p>
        </el-col>
        <el-col :span="4">
          <el-button v-if="updateProjectMicrolecturePassStatus" style="padding: 3px 0" type="text"
            @click="toUpdateProjectMicrolecturePassStatus">修改</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <p>是否隐藏演练分类:<span>{{ projectBase.aiTrainClassShow == 1 ? '否' : '是' }}</span></p>
        </el-col>
        <el-col :span="4">
          <el-button v-if="updateProjectAiTrainClassShow" style="padding: 3px 0" type="text"
            @click="toUpdateProjectAiTrainClassShow">修改</el-button>
        </el-col>
      </el-row>
    </el-card>
    <myform :viewobj="{
      updateProjectRankType: ['排行榜维度', 'el-icon-edit-outline'],
      $succeed$: getTheProjectOne,
    }" @confirm="submitForm">
      <hide slot="projectId" />
      <template v-slot:projectRankType="{ Myformdata }">
        <el-select v-model="Myformdata.projectRankType">
          <el-option v-for="item in theRankType || []" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </template>
    </myform>
    <myform :viewobj="{
      updateProjectOrderTimeEnd: ['编辑项目订单提交截止时间', 'el-icon-edit-outline'],
      $succeed$: getTheProjectOne,
    }" @confirm="submitForm">
      <hide slot="projectId" />
      <template v-slot:projectOrderTimeEnd="{ Myformdata }">
        <el-date-picker v-model="Myformdata.projectOrderTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择订单截止时间">
        </el-date-picker>
      </template>
    </myform>
    <myform :viewobj="{
      updateProjectMicrolecturePassStatus: ['微课匹配度校验', 'el-icon-edit-outline'],
      $succeed$: getTheProjectOne,
    }" @confirm="submitForm">
      <hide slot="projectId" />
      <template v-slot:microlecturePassStatus="{ Myformdata }">
        <el-select v-model="Myformdata.microlecturePassStatus">
          <el-option label="不校验" :value="1">
          </el-option>
          <el-option label="校验" :value="2">
          </el-option>
        </el-select>
      </template>
    </myform>
    <myform :viewobj="{
      updateProjectAiTrainClassShow: ['是否隐藏演练分类', 'el-icon-edit-outline'],
      $succeed$: getTheProjectOne,
    }" @confirm="submitForm2">
      <hide slot="projectId" />
      <template v-slot:aiTrainClassShow="{ Myformdata }">
        <el-select v-model="Myformdata.aiTrainClassShow">
          <el-option label="否" :value="1">
          </el-option>
          <el-option label="是" :value="2">
          </el-option>
        </el-select>
      </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectId: null,
      projectBase: {},
      //排行榜维度(1总金额 2年化金额)
      theRankType: [
        { id: 1, name: "总金额" },
        { id: 2, name: "年化金额" },
      ],
    };
  },

  watch: {},

  methods: {
    toUpdateProjectMicrolecturePassStatus() {
      this.$form("updateProjectMicrolecturePassStatus", this.projectBase);
    },
    toUpdateProjectAiTrainClassShow() {
      this.$form("updateProjectAiTrainClassShow", this.projectBase);
    },
    toUpdateProjectRankType() {
      this.$form("updateProjectRankType", this.projectBase);
    },
    toUpdateProjectOrderTimeEnd() {
      this.$form("updateProjectOrderTimeEnd", this.projectBase);
    },
    getTheProjectOne() {
      this.getProjectOne().result((res) => {
        this.projectBase = res.data.data;
      });
    },
    submitForm(submit, Myformdata) {
      Myformdata.projectId = A.local("$projectId");
      submit();
    },
    submitForm2(submit, Myformdata) {
      Myformdata.projectId = A.local("$projectId");
      submit();
    },
  },

  created() {
    this.getTheProjectOne();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/unipue/#ProjectOne.vue